const $ = require('jquery');

jQuery(document).ready(function() {

    // open modals
    $('[data-toggle="modal"]').click( function(e) {
        e.preventDefault();

        if ( ! $(this).hasClass('btn-disabled') ) {
            var target = $(this).data('modal-id');
            var $wrapper = $('.modals');
            var $modal = $wrapper.find('[data-modal-id="' + target + '"]');

            if ( $modal.length ) {
                $('body').addClass('show-modal');
                $wrapper.stop().fadeIn(150, 'easeInOutCubic', function () {
                    $modal.show();
                    setTimeout(function () {
                        $modal.addClass('modal--visible');
                    }, 100);
                });
            }
        }
    });

    $('.close-modal').click( function(e) {
        e.preventDefault();
        var $modal = $(this).closest('.modal');
        var $wrapper = $modal.closest('.modals');

        if( $modal.length ) {
            $('body').removeClass('show-modal');
            $modal.removeClass('modal--visible');
            setTimeout( function() {
                $wrapper.stop().fadeOut( 150, 'easeInOutCubic', function() {
                    $modal.hide();
                });
            }, 150 );
        }
    });


    $(document).on('click', function(e) {
        // close modal when clicking outside window
        if( !$(e.target).closest('.modal').length ) {
            if( $('.modals .modal.modal--visible').length ) {
                var $modal = $('.modals .modal.modal--visible');

                $('body').removeClass('show-modal');
                $modal.removeClass('modal--visible');
                setTimeout( function() {
                    $('.modals').stop().fadeOut( 150, 'easeInOutCubic', function() {
                        $modal.hide();
                    });
                }, 150 );
            }
        }
    });


    // if modal on pageload contains form with errors or confirmation messages, display modal
    $('.modals .modal').each( function() {
        var $modal = $(this);
        var $wrapper = $modal.closest('.modals');

        if( $modal.find('.gform_validation_error').length > 0 || $modal.find('.gform_confirmation_wrapper').length > 0 ) {
            $('body').addClass('show-modal');
            $wrapper.stop().fadeIn( 150, 'easeInOutCubic', function() {
                $modal.show();
                setTimeout( function() {
                    $modal.addClass('modal--visible');
                }, 100 );
            });
        }
    });

});
